import { List, ListItem } from '@mui/material';
import { styled } from '@mui/material/styles';

const AlphabeticalStyledComponents = {
  StyledAlphabet: styled(List)({
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    width: '100%',
    paddingBottom: '100px',
    maxWidth: '400px'
  }),
  StyledLetter: styled(ListItem)(({ theme }) => ({
    fontSize: '25px',
    width: '50px',
    height: '50px',
    display: 'flex',
    '&:hover': {
      backgroundColor: theme.palette.rowHover,
      cursor: 'pointer'
    }
  }))
};

export default AlphabeticalStyledComponents;
